export default __webpack_public_path__ + "static/media/lpu.38e71efa.png";